import rgbHex from 'rgb-hex'
import classNames from 'classnames'
import { FaCheck, FaTimes } from 'react-icons/fa'
import colors from '../../config/colors.json'
import { getPbgidIcon, usePbgidIcons } from '../../helpers/pbgidIcons'

// status: 'active' while researching, 'finished' or 'cancelled' once it has left the queue
export function LiveGameTechProgress({ pbgId, progress, secondsRemaining, color, status = 'active' }) {
	const pbgidIcons = usePbgidIcons()

	const icon = getPbgidIcon(pbgidIcons, parseInt(pbgId)) || '/liveGameIcons/unknown.png'
	const mainColor = rgbHex(colors[color]?.mainColor)

	const progressPercentage = Math.min(Math.max(progress, 0), 1) * 100 // Clamp between 0 and 100
	const isFinished = status === 'finished'
	const isCancelled = status === 'cancelled'

	return (
		<div
			className={classNames('liveGameTechProgress w-[40px] flex flex-col', {
				'liveGameTechProgress--finished': isFinished,
				'liveGameTechProgress--cancelled': isCancelled,
			})}
			style={{ backgroundColor: 'rgb(29, 39, 47)' }}>
			<div className="w-[40px] h-[40px]" style={{ backgroundImage: `url(/liveGameIcons/tech_background.png)`, backgroundSize: 'cover' }}>
				<img src={icon} alt="" className="w-full h-full" />
			</div>
			<div className="progressBar w-full h-[6px] bg-black border border-solid border-[#5E6989] box-border">
				<div
					className="h-full overflow-hidden"
					style={{
						backgroundColor: isCancelled ? '#6B7280' : `#${mainColor}`,
						width: `${progressPercentage}%`,
						transition: 'width 0.5s ease-in-out',
					}}>
					{status === 'active' && (
						<div
							className="h-full opacity-65 w-[138px] max-w-none bg-repeat-x"
							style={{
								backgroundImage: `url('/liveGameIcons/bar_dash.png')`,
								backgroundSize: 'cover',
								animation: 'barDash 8s linear infinite',
							}}></div>
					)}
				</div>
			</div>
			<div className="text-[#D2D2D2] text-lg leading-[20px] text-center">
				{isFinished ? (
					<FaCheck className="inline text-[#4ADE80] text-sm" />
				) : isCancelled ? (
					<FaTimes className="inline text-[#F87171] text-sm" />
				) : (
					`${Math.round(secondsRemaining)}s`
				)}
			</div>
		</div>
	)
}
